import ReactGA4 from 'react-ga4';

export type ProductEventTypes = {
  item_id: string;
  item_name: string;
  item_category?: string;
  currency?: string;
  discount?: number;
  affiliation?: string;
  price?: number;
  sale_price?: number;
  quantity?: number;
  coupon?: string;
  item_code?: string;
  item_sku_code?: string;
};

export type ViewItemProductEventTypes = {
  index?: number;
  item_list_id?: string;
  item_list_name?: string;
  item_variant?: string;
  promotion_id?: string;
  promotion_name?: string;
} & ProductEventTypes;

export type ProductCartEventTypes = {
  currency: string;
  value: number;
  coupon?: string;
  items: ViewItemProductEventTypes[];
};

export type ViewImageProductOnPopupEventTypes = {
  link_url?: string;
} & Pick<ProductEventTypes, 'item_name' | 'item_category' | 'item_code' | 'item_sku_code' | 'item_id'>;

export type SelectSizeProductEventTypes = {
  size: string;
} & Pick<ProductEventTypes, 'item_name' | 'item_category' | 'item_code' | 'item_sku_code'>;

export type SelectColorProductEventTypes = {
  color: string;
} & Pick<ProductEventTypes, 'item_name' | 'item_category' | 'item_code' | 'item_sku_code'>;

export type PromotionEventTypes = {
  creative_name?: string;
  creative_slot?: string;
  location_id?: string;
  promotion_id?: string;
  promotion_name?: string;
  items: ViewItemProductEventTypes[];
};

export type PaymentInfoEventTypes = {
  payment_type?: string;
} & ProductCartEventTypes;

export type DeliveryInfoEventTypes = {
  note?: string;
  name: string;
  phone: string;
  email?: string;
  street: string;
  province: string;
  ward: string;
  district: string;
  type: string;
  companyName: string;
  id?: number;
};

export type PurchaseEventTypes = {
  transaction_id: string;
  tax?: number;
  shipping?: number;
} & ProductCartEventTypes;

/**
 * Add to cart Tracking
 */

export function trackingAddToCartEvent(data: ProductCartEventTypes) {
  ReactGA4.event('add_to_cart', data);
}

/**
 * Detect item was selected from a list event
 */
export function trackingViewItemEvent(
  data: ProductCartEventTypes,
) {
  ReactGA4.event('view_item', data);
}

/**
 * purchase
 */
export function trackingPurchaseEvent(data: PurchaseEventTypes) {
  ReactGA4.event('purchase', data);
}
